import styled from '@emotion/styled';

interface StyledProps {
  isDragging: boolean;
  isOver?: boolean;
  canDrop?: boolean;
  isEditing?: boolean;
}

export const DragHandle = styled.div<StyledProps>`
  cursor: move;
  cursor: ${(props) => (props.isDragging || props.isOver || props.canDrop ? 'grabbing' : 'grab')};
  &:active {
    cursor: grabbing;
  }
`;

export const DragItem = styled.div<StyledProps>`
  opacity: ${(props) => (props.isDragging ? 0 : 1)};
  transform: translate(0, 0);
`;
